import { RouteConfig } from 'vue-router';

import GlobalAllocation from '@/modules/products/views/GlobalAllocation/GlobalAllocationView.vue';
import ProductsView from '@/modules/products/views/ProductsView/ProductsView.vue';
import { Products as ProductsCatalog } from '@/modules/catalog/views/Products';

export const productsRoutes: RouteConfig[] = [
  {
    name: 'productsView',
    path: '/products-view',
    component: ProductsView,
    meta: {
      isHomePage: true,
      context: 'products'
    }
  },
  {
    name: 'productsCatalog',
    path: '/products-view/catalog/:type/:productId?',
    component: ProductsCatalog,
    meta: {
      context: 'products'
    },
    props: () => ({
      isBuilder: false,
      cameFrom: 'productsView'
    })
  },
  {
    path: '/products-view/catalog',
    redirect: { name: 'productsCatalog', params: { type: 'fixed-income' } }
  },
  {
    name: 'productsAllocation',
    path: '/products/allocation',
    alias: '/overview/products-allocation',
    meta: { scroll: false },
    component: GlobalAllocation
  }
];
